export default __webpack_public_path__ + "static/media/partners.f198a382.svg";